export default __webpack_public_path__ + "static/media/Logout.76913f66.svg";